import { createFormValidation } from '#/utils/formValidation/toFormValidation';
import { TFunction } from '#hooks/useI18n';
import { FormValidation } from '@zazume/zzm-base';
import { PhoneVO, Schema, SchemaOf } from '@zazume/zzm-utils';

export type PhoneNumberInput = {
  contactPhone: string;
  queryReason: string;
}

const schema = (t: TFunction): SchemaOf<PhoneNumberInput> => {
  const requiredMessage = t('general.forms.mandatory');

  return Schema.isObject({
    contactPhone: Schema.isString().test('invalid-phone', t('general.forms.invalidPhone'), PhoneVO.isValid).required(requiredMessage),
    queryReason: Schema.isString().required(requiredMessage)
  });
};

export const getPhoneNumberSchema = (t: TFunction): FormValidation =>
  createFormValidation(t, schema(t));
